import { quickFacts } from '@/mocks/home';

export default function QuickFacts() {
  return (
    <section id="overview" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-2xl">
          <span className="text-primary-600 font-label text-sm tracking-wide">核心速览</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            两代作品，先看关键坐标
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            如果你只想知道最要紧的差异，这张速览表就够了：从年份、分级到主角与卖点，一目了然。想深入的话，往下每一节都有展开。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quickFacts.map((fact, index) => (
            <div
              key={fact.label}
              className="reveal bg-background-100/80 border border-background-200/80 rounded-lg p-5 md:p-6 transition-colors hover:border-primary-300"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <div className="flex items-center justify-between">
                <span className="text-foreground-500 text-xs md:text-sm font-label">{fact.label}</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-record-circle-line text-sm" />
                </span>
              </div>
              <p className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
                {fact.value}
              </p>
              <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed">{fact.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}